import { useAuthStep } from "@/hooks/useAuthStep";
import { useCommunication } from "@/lib/CommunicationWrapper";
import { CLOUDFLARE_URL } from "@/lib/config";
import { useEffect, useState } from "react";


export const ClaimTrial = () => {

    const { sendToBackgroundScript, authenticatedFetch, forceRefreshToken } = useCommunication();
    const [loading, setLoading] = useState(false);

    const { setAuthStep } = useAuthStep();

    const params = new URLSearchParams(window.location.search);
    const schoolOrigin = params.get("origin");

    const handleClaimTrial = async () => {
        setLoading(true);
        try {
            // Get the origin to redirect back after checkout
            const origin = window.location.origin;

            // Call backend to create Stripe checkout session
            const response = await authenticatedFetch(`${CLOUDFLARE_URL}/users/create-stripe-checkout`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: {
                    
                    priceKey: "learn_monthly", // Replace with your actual price ID
                    successUrl: `${window.location.origin}/success?origin=${schoolOrigin}`,
                    cancelUrl: `${window.location.origin}/cancel?origin=${schoolOrigin}`,
                    trial: true,
                },
            });

            if (!response.ok) {
                const error = await response.json();
                console.error("Failed to create checkout:", error);
                throw new Error(error.error || "Failed to create checkout session");
            }

            const data = await response.json();
            const checkoutUrl = data.message?.checkoutUrl;

            if (!checkoutUrl) {
                throw new Error("No checkout URL returned");
            }

            // Open the checkout URL with origin for redirect after checkout
            await sendToBackgroundScript({
                type: "OPEN_STRIPE",
                url: checkoutUrl,
                origin: window.location.origin
            });
        } catch (error) {
            console.error("Error creating Stripe checkout:", error);
            // TODO: Show error to user
        } finally {
        }

    }

    const messageListener = (event: MessageEvent) => {
        if (event.data.type === "STRIPE_SUCCESS_FORWARD") {
            console.log("STRIPE_SUCCESS_FORWARD received");
            setLoading(false);
            console.log("Force refreshing token");
            forceRefreshToken();
            console.log("Token force refreshed");
            setTimeout(() => {
                console.log("Setting auth step to trial claimed");
                setAuthStep("trialClaimed");
            }, 1000);
        }
    }

    useEffect(() => {
        window.addEventListener('message', messageListener);
        return () => {
            window.removeEventListener('message', messageListener);
        }
    }, []);

    const handleSkip = () => {
        setAuthStep("questionairre");
    }

    return (
        <div className="px-[30px] flex flex-col gap-2 text-center h-full justify-center mb-20">
            <h1 className="text-2xl font-semibold mb-2">Claim your free <span className="underline decoration-wavy decoration-orange-600 decoration-2 underline-offset-4">Learn+</span> trial</h1>
            <p className="text-gray-500 mb-6">Experience the full power of BetterCampus. Your card will not be charged for 7 days, cancel anytime.</p>
            <button onClick={handleClaimTrial} className="bg-brand-gradient text-white px-4 py-4 rounded-xl font-semibold">
                {loading ? "Loading..." : "Continue with free trial"}
            </button>
            <button onClick={handleSkip} className="text-gray-600 px-4 py-2 hover:text-black transition-all duration-200">
                Skip for now
            </button>
        </div>
    )
}